
import analysismodelCanvas from '../js/fiveElesAnalysisModel';
import XButton from 'vux/src/components/x-button/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'

import Clipboard from 'clipboard';
let clipboard = new Clipboard('.copyBtn');
export default {
name:'result',
data(){
return{
username:'',
birthday:'',
mingwei:[],
resTitle:'',
valArr:[],
show2:false,
tel:18612374027,
menus:{
menu1: ('直接分享给朋友'),
menu2: ('生成专属二维码分享')
},
option : {
radar: [
{
indicator: [
{ text: '水',max: 4 },
{ text: '火',max: 4 },
{ text: '木',max: 4 },
{ text: '土',max: 4 },
{ text: '金',max: 4 }
],
radius: 100,
startAngle: 60,
splitNumber: 4,
shape: 'circle',
name: {
formatter:'{value}',
textStyle: {
color:'#666'
}
},
splitArea: {
areaStyle: {
color: ['#fff',
'#fff', '#fff',
'#fff', '#333'],
shadowColor: 'rgba(0, 0, 0, 0.3)',
shadowBlur: 1
}
},
axisLine: {
lineStyle: {
color: '#d7d7d7'
}
},
splitLine: {
lineStyle: {
color: '#eaeaea'
}
}
},
],

series: [
{
name: '雷达图',
type: 'radar',
itemStyle: {
emphasis: {

lineStyle: {
width: 1
}
}
},
data: [
{
value: [1,1,1,1,1],//水，火，木，土，金
name: '图一',


lineStyle: {
normal: {
width: '1'
}
}
},
]
},
]
},
jiedu:[],
jieduTitle:[]
}
},
components: {
XButton,
Actionsheet
},
mounted(){
this.$http.post('/wuxingTestResult',{d_id:this.$route.query.id}).then(ress=>{
let res = ress.body.result
this.username = res.nickname
this.birthday = res.birthday
this.mingwei = res.mingweiwuxing.split(',')
this.jiedu = res.thewuxingMYFX
var arr = [
['水','水','火', '火', '土', '金', '金','木', '木',],
['金', '金','水', '水' , '土','木', '木', '火', '火', ],
['木', '木','金', '金' ,'水', '水', '土', '火', '火', ],
['水', '土', '土',  '金', '金', '木', '木','火', '火',],
['火', '火', '木', '木' , '水', '水', '土','金', '金',]
]
var wuxing = [
'火',
'水',
'金',
'土',
'木',
]
for(let jie=0;jie<this.jiedu.length;jie++){
let title = wuxing[jie]+ '上' + arr[jie][this.jiedu[jie].xu-1]
this.jieduTitle[jie] = title
}
console.log(this.jieduTitle)
analysismodelCanvas("analysisModel", res.thenum.split(","));
var myChart = echarts.init(document.getElementById('fiveChart'));
this.option.radar[0].center = [(document.getElementById('fiveChart').offsetWidth/2)-12 + 'px',(document.getElementById('fiveChart').offsetHeight/2) - 2 + 'px']
let wx = {
0:1,
1:0,
2:4,
3:3,
4:2
}
for(let i = 0;i<5;i++){
if(res.rescount[i]){
this.option.series[0].data[0].value[i] = Number(res.rescount[wx[i]].substring(3,2)) + 1
if(this.option.series[0].data[0].value[i]>3){
this.option.series[0].data[0].value[i] = 4
}
}else{
this.option.series[0].data[0].value[i] = 1
}
}
console.log(this.option.series[0].data[0].value)
myChart.setOption(this.option);
let jieguo = ''
let jieguoq = ''
let resultq = ''
let num = 0;
for(let j=0;j<5;j++){
if(res.rescount[j].substring(3,2)!='0'){
jieguo = jieguo + res.rescount[j].substring(3,2) + res.rescount[j].substring(0,1)
}
}
for(let q=0;q<5;q++){
if(res.rescount[q].substring(3,2)=='0'){
if(num==0){
jieguoq = jieguoq + '缺' + res.rescount[q].substring(0,1)
}else{
jieguoq = jieguoq + res.rescount[q].substring(0,1)
}
num+=1
}
}
resultq= jieguo +jieguoq
this.resTitle = resultq
console.log(resultq)
})
},
methods:{
share(){



wx.miniProgram.navigateTo({url: '/pages/share/main'})



},
onCopy: function (e) {
this.$vux.toast.text('已将内容复制到剪切板', 'center')
},
onError: function (e) {
console.log('无法复制文本！')
}
}
}



// WEBPACK FOOTER //
// ./src/components/result.vue